import { useEffect, useState } from "react"
import NotesDrawer from "../notifications/notes-drawer"
import InboxDrawer from "../notifications/updates-drawer"
import NotificationDrawer from "../notifications/notification-drawer"
import WorkDiariesComment from "../projects/work-diaries-comment"

export const DrawerProvider = () => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return null
  }

  return (
    <>
      <NotesDrawer />
      <InboxDrawer />
      <NotificationDrawer />
      <WorkDiariesComment />
    </>
  )
}
